import { render, staticRenderFns } from "./banner_template.vue?vue&type=template&id=18960b92&scoped=true"
import script from "./banner_template.vue?vue&type=script&lang=js"
export * from "./banner_template.vue?vue&type=script&lang=js"
import style0 from "./banner_template.vue?vue&type=style&index=0&id=18960b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18960b92",
  null
  
)

export default component.exports